"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewProductsWidgetContent = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const react_redux_1 = require("react-redux");
const preview_products_widget_content_styles_1 = require("./preview-products-widget-content.styles");
const products_preview_1 = require("./products-preview");
const products_table_1 = require("../../store/catalogs/products-table");
const strategy_attributes_1 = require("../strategy-attributes");
const hooks_1 = require("./products-preview/hooks");
const store_1 = require("../../../store");
const PreviewProductsWidgetContent = ({ onReEnrich, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isAggregatedAttributeViewHidden = (0, store_1.useIsAggregatedAttributeViewHidden)();
    const isListViewMode = (0, store_1.useIsListViewMode)();
    const selectedCatalog = (0, store_1.useSelectedCatalogId)();
    const rowSize = (0, products_table_1.useProductsTableRowSize)();
    const areProductsViewQueryParamsReady = (0, hooks_1.useProductsViewQueryParamsSync)();
    const toggleAttributeSectionVisibility = (0, react_1.useCallback)(() => dispatch((0, store_1.enrichAISetIsAggregatedAttributeViewHidden)(!isAggregatedAttributeViewHidden)), [dispatch, isAggregatedAttributeViewHidden]);
    const toggleViewMode = (0, react_1.useCallback)(() => dispatch((0, store_1.enrichAISetIsListViewMode)(!isListViewMode)), [dispatch, isListViewMode]);
    const toggleRowSize = (0, react_1.useCallback)(() => dispatch((0, products_table_1.setProductsTableRowSize)(selectedCatalog, rowSize === ui_components_1.DataGridRowSize.Standard ? ui_components_1.DataGridRowSize.Adaptive : ui_components_1.DataGridRowSize.Standard)), [dispatch, selectedCatalog, rowSize]);
    return (react_1.default.createElement(preview_products_widget_content_styles_1.StyledProductsContainer, null, react_1.default.createElement(preview_products_widget_content_styles_1.StyledTabsContainer, null, !isAggregatedAttributeViewHidden && (react_1.default.createElement(strategy_attributes_1.StrategyAttributesContainer, { onReEnrich: onReEnrich })), areProductsViewQueryParamsReady && (react_1.default.createElement(products_preview_1.ProductsPreviewContainer, { isAttributesSectionVisible: !isAggregatedAttributeViewHidden, isListViewMode: isListViewMode, toggleAttributeSectionVisibility: toggleAttributeSectionVisibility, toggleViewMode: toggleViewMode, onChangeRowSize: toggleRowSize, rowSize: rowSize })))));
};
exports.PreviewProductsWidgetContent = PreviewProductsWidgetContent;
